export const bellIcon = (
  <svg fill="none" height="72" role="presentation" viewBox="0 0 72 72" width="72" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_b_17274_211360)">
      <circle cx="36" cy="36" fill="url(#paint0_radial_17274_211360)" fillOpacity="0.4" r="36" />
      <circle cx="36" cy="36" r="35.5" stroke="#2F4462" strokeOpacity="0.24" />
    </g>
    <g filter="url(#filter1_d_17274_211360)">
      <path
        d="M36.018 48C34.6913 47.9935 33.6155 46.9247 33.6024 45.6H38.4096C38.4125 45.9208 38.3516 46.2389 38.2305 46.536C37.9151 47.2583 37.2712 47.7851 36.5 47.952H36.4939H36.4783H36.4663H36.4531H36.4447C36.3042 47.9811 36.1614 47.9971 36.018 48ZM45.6325 44.4H26.4036V42L28.8072 40.8V34.2C28.7439 32.5069 29.1268 30.827 29.9177 29.328C30.7049 27.9378 32.0505 26.9507 33.6144 26.616V24H38.4216V26.616C41.5211 27.3528 43.2288 30.0456 43.2288 34.2V40.8L45.6325 42V44.4ZM48 33.6H45.5964C45.4845 30.4967 43.9904 27.6054 41.5223 25.716L43.2288 24C44.6663 25.1166 45.8278 26.5477 46.6239 28.1832C47.4472 29.8764 47.9154 31.7197 48 33.6ZM26.4036 33.6H24C24.0846 31.7197 24.5528 29.8764 25.3761 28.1832C26.1722 26.5477 27.3337 25.1166 28.7712 24L30.4777 25.716C28.0094 27.6052 26.5152 30.4966 26.4036 33.6Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="84"
        id="filter0_b_17274_211360"
        width="84"
        x="-6"
        y="-6"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="3" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_17274_211360" />
        <feBlend in="SourceGraphic" in2="effect1_backgroundBlur_17274_211360" mode="normal" result="shape" />
      </filter>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="56"
        id="filter1_d_17274_211360"
        width="56"
        x="8"
        y="8"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="8" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.48 0" />
        <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_17274_211360" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_17274_211360" mode="normal" result="shape" />
      </filter>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(36 27) rotate(90) scale(52.2)"
        gradientUnits="userSpaceOnUse"
        id="paint0_radial_17274_211360"
        r="1"
      >
        <stop stopColor="#2B4573" />
        <stop offset="0.80794" stopColor="#00112E" />
      </radialGradient>
    </defs>
  </svg>
);

export const bellIconSmall = (
  <svg fill="none" height="47" viewBox="0 0 47 47" width="47" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_b_28484_182061)">
      <circle cx="23.5" cy="23.5" fill="#1C2331" r="21.5" />
      <circle cx="23.5" cy="23.5" fill="url(#paint0_radial_28484_182061)" fill-opacity="0.4" r="21.5" />
      <circle cx="23.5" cy="23.5" r="21" stroke="#2F4462" stroke-opacity="0.24" />
    </g>
    <g filter="url(#filter1_d_28484_182061)">
      <path
        d="M23.5104 30.6668C22.7181 30.663 22.0756 30.0246 22.0678 29.2335H24.9388C24.9405 29.4251 24.9041 29.6151 24.8318 29.7925C24.6434 30.2239 24.2589 30.5385 23.7983 30.6382H23.7947H23.7853H23.7782H23.7703H23.7652C23.6814 30.6555 23.5961 30.6651 23.5104 30.6668ZM29.2524 28.5168H17.7685V27.0835L19.204 26.3668V22.4252C19.1662 21.414 19.3949 20.4107 19.8672 19.5155C20.3373 18.6852 21.141 18.0957 22.075 17.8958V16.3335H24.9459V17.8958C26.797 18.3359 27.8169 19.9441 27.8169 22.4252V26.3668L29.2524 27.0835V28.5168ZM30.6663 22.0668H29.2309C29.164 20.2135 28.2717 18.4867 26.7977 17.3583L27.8169 16.3335C28.6754 17.0003 29.3691 17.8551 29.8445 18.8318C30.3362 19.843 30.6158 20.9439 30.6663 22.0668ZM17.7685 22.0668H16.333C16.3835 20.9439 16.6632 19.843 17.1548 18.8318C17.6303 17.8551 18.324 17.0003 19.1824 16.3335L20.2016 17.3583C18.7275 18.4866 17.8351 20.2134 17.7685 22.0668Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
        height="203"
        id="filter0_b_28484_182061"
        width="203"
        x="-78"
        y="-78"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="40" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_28484_182061" />
        <feBlend in="SourceGraphic" in2="effect1_backgroundBlur_28484_182061" mode="normal" result="shape" />
      </filter>
      <filter
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
        height="46.3333"
        id="filter1_d_28484_182061"
        width="46.333"
        x="0.333008"
        y="0.333496"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="8" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.48 0" />
        <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_28484_182061" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_28484_182061" mode="normal" result="shape" />
      </filter>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(23.5 18.125) rotate(90) scale(31.175)"
        gradientUnits="userSpaceOnUse"
        id="paint0_radial_28484_182061"
        r="1"
      >
        <stop stop-color="#005EFF" />
        <stop offset="0.80794" stop-color="#00112E" />
      </radialGradient>
    </defs>
  </svg>
);

export const successIcon = (
  <svg fill="none" height="72" role="presentation" viewBox="0 0 72 72" width="72" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_b_17274_211586)">
      <circle cx="36" cy="36" fill="url(#paint0_radial_17274_211586)" fillOpacity="0.4" r="36" />
      <circle cx="36" cy="36" r="35.5" stroke="#2F4462" strokeOpacity="0.24" />
    </g>
    <g filter="url(#filter1_d_17274_211586)">
      <path
        d="M30.6667 48L21 38.1828L25.2987 33.8172L30.6667 39.2842L45.7013 24L50 28.3656L30.6667 48Z"
        fill="#A8FF64"
      />
    </g>
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="84"
        id="filter0_b_17274_211586"
        width="84"
        x="-6"
        y="-6"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="3" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_17274_211586" />
        <feBlend in="SourceGraphic" in2="effect1_backgroundBlur_17274_211586" mode="normal" result="shape" />
      </filter>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="56"
        id="filter1_d_17274_211586"
        width="61"
        x="5"
        y="8"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="8" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.658824 0 0 0 0 1 0 0 0 0 0.392157 0 0 0 0.48 0" />
        <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_17274_211586" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_17274_211586" mode="normal" result="shape" />
      </filter>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(36 27) rotate(90) scale(52.2)"
        gradientUnits="userSpaceOnUse"
        id="paint0_radial_17274_211586"
        r="1"
      >
        <stop stopColor="#2B7350" />
        <stop offset="0.80794" stopColor="#00112E" />
      </radialGradient>
    </defs>
  </svg>
);
